<template>
  <table :class="['product-rows', {'product-rows--readonly': isReadOnlyTable}]">
    <thead>
      <tr>
        <th class="product-row__head-image"></th>

        <th class="product-row__head-article-name">
          <div class="product-row__head-inset">
            <span>
              {{ tStatic('cartProductHeaderLabel') }}
            </span>
          </div>
        </th>

        <th class="product-row__head-stock-status">
          <div class="product-row__head-inset">
            {{ tStatic('cartStatusSendNowLabel') }}
          </div>
        </th>

        <th class="product-row__head-stock-status">
          <div class="product-row__head-inset">
            {{ tStatic('cartStatusSendLaterLabel') }}
          </div>
        </th>

        <th :class="{'product-row__head-quantity': !hideEdits}">
          <div class="product-row__head-inset">
            {{ tStatic('cartQuantityLabel') }}
          </div>
        </th>

        <th class="product-row__head-comment">
          <div class="product-row__head-inset">
            {{ tStatic('cartRowCommentLabel') }}
          </div>
        </th>

        <th class="product-row__head-item-price">
          <div class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ tStatic('cartRowPriceLabel') }}</span>
          </div>
        </th>

        <th class="product-row__head-total-price">
          <div class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ tStatic('cartRowPriceTotalLabel') }}</span>
          </div>
        </th>

        <th v-if="!hideEdits" class="product-row__head-remove">
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="row of cart.rows" :key="`table-row-${row.itemId}`">
        <td class="product-row__body-td--image">
          <div class="product-row__body-inset product-row__body-inset--article">
            <img
              v-if="row.item.image"
              :src="row.item.image + '?preset=ProductThumb&watermark=OIEWatermarkSmall'"
              :alt="row.displayName"
              class="">
            <img
              v-else
              src="/globalassets/missing404/404.png?preset=ProductThumb"
              class="">
          </div>
        </td>

        <td class="product-row__body-td--article">
          <div class="product-row__body-inset product-row__body-inset--article">
            <a v-if="clientModel.cartType === 0 && row.item.url" :href="row.item.url" class="product-row__name">
              {{ row.displayName }}
            </a>
            <div v-else class="product-row__name">
              {{ row.displayName }}
            </div>

            <div class="product-row__article-number">
              {{ `${tStatic('headerCartItemNumberLabel')} ${row.itemId}` }}
            </div>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic('cartStatusSendNowLabel') }}
          </div>

          <div class="product-row__body-inset">
            <oie-product-status
              v-if="(row.stock) <= 0"
              status="in-stock"
              text="0"
              size="medium"></oie-product-status>
            <oie-product-status
              v-else-if="(row.stock - row.quantity) > 0"
              status="in-stock"
              :text="calculateStock(0, row.quantity)"
              size="medium"></oie-product-status>
            <oie-product-status
              v-else-if="row.stock <= row.quantity"
              status="in-stock"
              :text="calculateStock(row.stock, 0)"
              size="medium"></oie-product-status>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic('cartStatusSendLaterLabel') }}
          </div>
          <div class="product-row__body-inset">
            <oie-product-status
              v-if="row.stock < 0"
              status="few-stock"
              :text="`${row.quantity}`"
              size="medium"></oie-product-status>
            <oie-product-status
              v-else
              status="few-stock"
              :text="calculateStock(row.stock, row.quantity)"
              size="medium"></oie-product-status>
            <!-- <oie-product-status
              :else-v-if="(row.quantity - row.stock) <= 0"
              status="few-stock"
              text="0"
              size="medium"></oie-product-status> -->
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic('cartQuantityLabel') }}
          </div>

          <div class="product-row__body-inset">
            <oie-product-quantity v-if="!hideEdits" :cart-row="row" :cart-name="cart.name"></oie-product-quantity>

            <template v-else>
              {{ row.quantity }}
            </template>
          </div>
        </td>

        <td class="product-row__td--comment">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic('cartRowCommentLabel') }}
          </div>

          <div class="product-row__body-inset">
            <template>
              {{ row.comment }}
            </template>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic('cartRowPriceLabel') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.price) }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ tStatic('cartRowPriceTotalLabel') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(row.price * row.quantity) }}
          </div>
        </td>
        <td v-if="!hideEdits">
          <div class="product-row__body-inset product-row__body-inset--remove">
            <oie-base-button css-classes="product-row__remove-button" @click="deleteFromCart(row.id)"></oie-base-button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    hideEdits: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    quickAddNumber: '',
    comment: '',
    commentIsActive: false,
    commentSaveDisabled: true

  }),
  computed: {
    ...mapGetters('commerce', ['cart']),
    count() {
      return _.chain(this.cart.rows).map(row => row.quantity).sum().value()
    },
    totalPrice() {
      return this.cart.totalPrice + this.cart.shippingFee
    },
    isReadOnlyTable() {
      if(this.clientModel.cartType === 0) {
        return false
      }
      return true
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('commerce', ['deleteFromCart']),
    calculateStock(stock, quantity) {
      if(stock === 0) { return (quantity).toString() }
      if(stock > quantity && quantity > 0) { return (0).toString() }
      if(quantity === 0) { return (stock).toString() }

      return (quantity - stock).toString()
    }
  }
}
</script>
